document.addEventListener('DOMContentLoaded',()=>{
const CONFIG={breakpoint:990,duration:300,wheelThreshold:18,wheelRelease:110,touchThreshold:45,directionRatio:1.15};
const selectors=['.home-hero','.home-shop-products','.home-our-story','.home-why-5ive','.home-skincare-ritual','.home-reviews','.home-before-after','.home-faq'];
const labels={'.home-hero':'Home','.home-shop-products':'Shop','.home-our-story':'Our Story','.home-why-5ive':'Why 5ive','.home-skincare-ritual':'Ritual','.home-reviews':'Reviews','.home-before-after':'Results','.home-faq':'FAQ'};
const sections=[];
selectors.forEach(selector=>{
const section=document.querySelector(selector);
if(!section)return;
section.classList.add('home-scroll-section');
section.dataset.homeScrollSelector=selector;
sections.push(section);
});
if(sections.length<2)return;
const nav=document.createElement('nav');
nav.className='home-section-nav';
nav.setAttribute('aria-label','Homepage section navigation');
sections.forEach((section,index)=>{
const selector=section.dataset.homeScrollSelector;
const label=labels[selector]||`Section ${index+1}`;
const button=document.createElement('button');
button.type='button';
button.className='home-section-nav__item';
button.dataset.index=index;
button.setAttribute('aria-label',`Go to ${label}`);
const dot=document.createElement('span');
dot.className='home-section-nav__dot';
const tooltip=document.createElement('span');
tooltip.className='home-section-nav__label';
tooltip.textContent=label;
button.append(dot,tooltip);
nav.appendChild(button);
});
document.body.appendChild(nav);
const navItems=[...nav.querySelectorAll('.home-section-nav__item')];
let animating=false;
let frame=null;
let wheelTotal=0;
let wheelTimer=null;
let wheelLocked=false;
let touchStartX=0;
let touchStartY=0;
let touchCurrentX=0;
let touchCurrentY=0;
let touchDirection=null;
let touchCaptured=false;
let touchTarget=null;
let scrollTicking=false;
const getHeaderOffset=()=>{
const header=document.querySelector('.custom-header');
if(!header)return 0;
const style=getComputedStyle(header);
return style.position==='fixed'||style.position==='sticky'?header.offsetHeight:0;
};
const getViewport=()=>Math.max(window.innerHeight-getHeaderOffset(),1);
const getTop=section=>window.scrollY+section.getBoundingClientRect().top-getHeaderOffset();
const getBottom=section=>getTop(section)+section.offsetHeight;
const getMaxScroll=()=>Math.max(document.documentElement.scrollHeight-window.innerHeight,0);
const clamp=y=>Math.max(0,Math.min(y,getMaxScroll()));
const updateNav=index=>{
if(index<0||index>=sections.length)return;
navItems.forEach((item,i)=>{
const active=i===index;
item.classList.toggle('is-active',active);
if(active)item.setAttribute('aria-current','true');
else item.removeAttribute('aria-current');
});
};
const currentIndex=()=>{
const point=getHeaderOffset()+getViewport()*.45;
for(let i=0;i<sections.length;i++){
const rect=sections[i].getBoundingClientRect();
if(rect.top<=point&&rect.bottom>=point)return i;
}
let closest=0;
let distance=Infinity;
sections.forEach((section,index)=>{
const rect=section.getBoundingClientRect();
const d=Math.min(Math.abs(rect.top-point),Math.abs(rect.bottom-point));
if(d<distance){
distance=d;
closest=index;
}
});
return closest;
};
const ease=t=>1-Math.pow(1-t,3);
const animateTo=(target,index)=>{
if(frame)cancelAnimationFrame(frame);
const start=window.scrollY;
target=clamp(target);
const distance=target-start;
if(Math.abs(distance)<2){
window.scrollTo(0,target);
updateNav(index);
return;
}
animating=true;
updateNav(index);
const startTime=performance.now();
const step=now=>{
const progress=Math.min((now-startTime)/CONFIG.duration,1);
window.scrollTo(0,start+distance*ease(progress));
if(progress<1){
frame=requestAnimationFrame(step);
return;
}
window.scrollTo(0,target);
frame=null;
animating=false;
};
frame=requestAnimationFrame(step);
};
const scrollableParent=(target,direction)=>{
if(!(target instanceof Element))return null;
let element=target;
while(element&&element!==document.body){
const style=getComputedStyle(element);
const scrollable=(style.overflowY==='auto'||style.overflowY==='scroll')&&element.scrollHeight>element.clientHeight+3;
if(scrollable){
const down=element.scrollTop+element.clientHeight<element.scrollHeight-3;
const up=element.scrollTop>3;
if(direction>0&&down)return element;
if(direction<0&&up)return element;
}
element=element.parentElement;
}
return null;
};
const insideSections=()=>{
const y=window.scrollY;
const first=getTop(sections[0]);
const last=getBottom(sections[sections.length-1]);
return y>=first-5&&y<=last-5;
};
const targetForDirection=direction=>{
const index=currentIndex();
const section=sections[index];
const viewport=getViewport();
const top=getTop(section);
const end=Math.max(top,getBottom(section)-viewport);
const y=window.scrollY;
const tolerance=8;
const tall=section.offsetHeight>viewport+tolerance;
if(direction>0){
if(tall&&y<end-tolerance)return null;
if(index>=sections.length-1)return false;
return{index:index+1,y:getTop(sections[index+1])};
}
if(tall&&y>top+tolerance)return null;
if(index<=0)return false;
const previous=sections[index-1];
const previousTop=getTop(previous);
const previousEnd=Math.max(previousTop,getBottom(previous)-viewport);
const previousTall=previous.offsetHeight>viewport+tolerance;
return{index:index-1,y:previousTall?previousEnd:previousTop};
};
const horizontalControl=target=>{
if(!(target instanceof Element))return false;
return Boolean(target.closest('.home-before-after,[data-before-after],[data-slider],input[type="range"],.swiper,.splide,.slider,.carousel'));
};
navItems.forEach((button,index)=>{
button.addEventListener('click',()=>{
wheelLocked=false;
wheelTotal=0;
animateTo(getTop(sections[index]),index);
});
});
window.addEventListener('wheel',event=>{
if(event.ctrlKey||event.deltaY===0)return;
if(Math.abs(event.deltaX)>Math.abs(event.deltaY))return;
const direction=event.deltaY>0?1:-1;
if(scrollableParent(event.target,direction))return;
if(!insideSections())return;
const target=targetForDirection(direction);
if(target===null)return;
if(target===false)return;
event.preventDefault();
if(animating||wheelLocked)return;
wheelTotal+=event.deltaY;
clearTimeout(wheelTimer);
wheelTimer=setTimeout(()=>{
wheelTotal=0;
wheelLocked=false;
},CONFIG.wheelRelease);
if(Math.abs(wheelTotal)<CONFIG.wheelThreshold)return;
wheelLocked=true;
wheelTotal=0;
animateTo(target.y,target.index);
},{passive:false});
document.addEventListener('touchstart',event=>{
if(!event.touches||event.touches.length!==1)return;
const touch=event.touches[0];
touchStartX=touch.clientX;
touchStartY=touch.clientY;
touchCurrentX=touch.clientX;
touchCurrentY=touch.clientY;
touchDirection=null;
touchCaptured=false;
touchTarget=event.target;
},{passive:true});
document.addEventListener('touchmove',event=>{
if(!event.touches||event.touches.length!==1)return;
const touch=event.touches[0];
touchCurrentX=touch.clientX;
touchCurrentY=touch.clientY;
const dx=touchCurrentX-touchStartX;
const dy=touchCurrentY-touchStartY;
if(touchDirection===null&&(Math.abs(dx)>8||Math.abs(dy)>8)){
if(Math.abs(dx)>Math.abs(dy)*CONFIG.directionRatio)touchDirection='horizontal';
else if(Math.abs(dy)>Math.abs(dx)*CONFIG.directionRatio)touchDirection='vertical';
}
if(touchDirection!=='vertical')return;
if(horizontalControl(touchTarget)&&Math.abs(dx)>Math.abs(dy))return;
const direction=dy<0?1:-1;
if(scrollableParent(touchTarget,direction))return;
if(!insideSections())return;
const target=targetForDirection(direction);
if(target===null||target===false)return;
event.preventDefault();
touchCaptured=true;
},{passive:false});
document.addEventListener('touchend',()=>{
if(touchDirection!=='vertical'||!touchCaptured){
touchDirection=null;
touchCaptured=false;
return;
}
const dx=touchCurrentX-touchStartX;
const dy=touchCurrentY-touchStartY;
if(Math.abs(dy)<CONFIG.touchThreshold||Math.abs(dy)<=Math.abs(dx)*CONFIG.directionRatio){
touchDirection=null;
touchCaptured=false;
return;
}
const direction=dy<0?1:-1;
const target=targetForDirection(direction);
if(target&&target!==null&&!animating)animateTo(target.y,target.index);
touchDirection=null;
touchCaptured=false;
},{passive:true});
document.addEventListener('touchcancel',()=>{
touchDirection=null;
touchCaptured=false;
},{passive:true});
document.addEventListener('keydown',event=>{
if(document.activeElement&&document.activeElement.matches('input,textarea,select,[contenteditable="true"]'))return;
const direction=event.key==='ArrowDown'||event.key==='PageDown'?1:event.key==='ArrowUp'||event.key==='PageUp'?-1:0;
if(!direction||!insideSections()||animating)return;
const target=targetForDirection(direction);
if(!target||target===null)return;
event.preventDefault();
animateTo(target.y,target.index);
});
window.addEventListener('scroll',()=>{
if(scrollTicking)return;
scrollTicking=true;
requestAnimationFrame(()=>{
if(!animating)updateNav(currentIndex());
scrollTicking=false;
});
},{passive:true});
window.addEventListener('resize',()=>{
wheelTotal=0;
wheelLocked=false;
},{passive:true});
updateNav(currentIndex());
});